'use client';

import { type User } from 'payload';
import { createContext, type ReactNode, useContext } from 'react';

interface AdminContextType {
  user: User | null;
  preview: boolean;
}

const AdminContext = createContext<AdminContextType>({
  user: null,
  preview: false,
});

export const AdminProvider = ({
  children,
  user,
  preview,
}: {
  children: ReactNode;
} & AdminContextType) => {
  return <AdminContext value={{ user, preview }}>{children}</AdminContext>;
};

export const useAdminContext = () => {
  return useContext(AdminContext);
};
